import type { IWorkJourneyMatrixCell } from '@src/models/interfaces/workJourneyManagement.interface';

import { getMatrixTodayIsoDate } from './isFutureMatrixCalendarDate';

/**
 * Optimistic chip after creating an AR for a previously blank past/today day.
 * Past incomplete days match listMonthMatrix (AUI); today stays planned WORK.
 */
export const buildCreatedPastDayMatrixCell = (params: {
  userId: string;
  date: string;
  attendanceRecordId: string;
  displayName?: string;
  idCard?: string | null;
  /** Override "today" for tests (`YYYY-MM-DD`). */
  todayIso?: string;
}): IWorkJourneyMatrixCell => {
  const todayIso = params.todayIso ?? getMatrixTodayIsoDate();
  const isPastDay = params.date < todayIso;
  const kind = isPastDay ? 'unjustified_absence' : 'planned';
  const code = isPastDay ? 'AUI' : 'WORK';

  return {
    userId: params.userId,
    date: params.date,
    kind,
    code,
    leaveType: null,
    observation: null,
    attendanceCompleted: false,
    attendanceRecordId: params.attendanceRecordId,
    subjectDisplayName: params.displayName,
    subjectIdCard: params.idCard ?? undefined,
    attendance: {
      leaveType: null,
      observations: null,
      attendanceComplete: false,
      hasActualStart: false,
    },
  };
};
